<script setup>
import { useToastStore } from '@/composables/stores';
const toasts = useToastStore();
</script>

<template>
  <div class="toast-host" role="status" aria-live="polite">
    <transition-group name="toast">
      <div v-for="t in toasts.list" :key="t.id" class="toast" :class="`toast--${t.kind}`">{{ t.text }}</div>
    </transition-group>
  </div>
</template>

<style scoped>
.toast-host {
  position: fixed;
  bottom: 180px;
  inset-inline-end: 16px;
  display: grid;
  gap: 8px;
  z-index: 80;
  pointer-events: none;
}
.toast {
  background: var(--ink-strong);
  color: #fff;
  padding: 10px 16px;
  border-radius: var(--radius);
  box-shadow: var(--shadow-lg);
  font-size: 14px;
  font-weight: 600;
}
.toast--success { background: var(--brand-success); }
.toast--error { background: var(--brand-red); }
.toast-enter-active, .toast-leave-active { transition: all var(--t-slow) var(--ease); }
.toast-enter-from, .toast-leave-to { transform: translateY(8px); opacity: 0; }
</style>
